import { ConfigProvider, Empty } from "antd";
import React from "react";
import { ButtonUi } from "./ButtonUi";
import { TipoButtonConstants } from "../../types/typesConstants";
const TableEmpty = (handleAdd, message) => (
  <Empty description={message}>
    <ButtonUi
      typeUi={TipoButtonConstants.AgregarTable}
      onClick={handleAdd} // insert an empty string at a position
    />
  </Empty>
);
export const TableEmptyUi = (handleAdd, message) => {
  return (
    <ConfigProvider
      renderEmpty={() => TableEmpty(handleAdd, message)}
    ></ConfigProvider>
  );
};
